<script setup> 
import PremiumPageHeader from '@/Components/PremiumPageHeader.vue';
import { ref } from "vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head } from '@inertiajs/inertia-vue3';
import BaseButton from "@/Components/BaseButton.vue";
import { mdiPlusCircle } from "@mdi/js";
import CardBox from "@/Components/CardBox.vue";
import TableSingle from "@/Components/TableSingle.vue";
defineProps({
    typedocs: Array
});
const rutaPrefijo = ref('typedoc');
</script>

<template>

    <Head title="Config. Tipo de documentos" />

    <BreezeAuthenticatedLayout>


        <template #header>
        <PremiumPageHeader :icon="mdiCog" title="Tipo de documentos" subtitle="Gestión de tipo de documentos">
        </PremiumPageHeader>
    </template>


        <div>
            <div class="bg-white overflow-hidden border rounded-md shadow-lg p-4">
                <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->

                <CardBox has-table>
                    <!-- Tablesingle opciones: checkable -->
                    <TableSingle isRef :data="typedocs" :ruta="rutaPrefijo" />
                </CardBox>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>
